



















import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';

@Component
export default class Rule extends Vue {
  rulecontent: any = {};
  async mounted() {
    const ret = await getRule();
    this.rulecontent = ret.data;
  }
  goback() {
    this.$router.push('index');
  }
}
